import React, { useEffect, useState } from "react";
import CurrencyItems from "./currencyItems";
import Spinner from "../../../shared/spinner";
import SwiperCurrency from "./swiperCurrency";
import photoCurrency from "../../../assets/icons/nerkh-arz.svg";

const Currency = ({ data, showSidbarMarginLeft, currUpdatedAt }) => {
  if (data === undefined || data.length === 0) {
    return <Spinner />;
  }

  return (
    <div className="pt-2 pb-16 bg-gradient-to-t from-[#faf838] via-transparent  to-transparent ">
      <div
        className=" w-[60%] mx-auto py-4 px-2 text-right  flex flex-row-reverse
         screen800:w-[78%] 
         screen700:w-[82%] screen500:w-[93%]  screen500:gap-0 screen500:gap-y-3 screen370:w-[100%]"
      >
        <div className="">
          <img
            src={photoCurrency}
            alt="ارز صرافی روبین"
            className={` ${showSidbarMarginLeft ? "w-8 h-8" : "w-12 h-12"} `}
          />
        </div>

        <div
          className={` text-white font-bold   my-auto ${
            showSidbarMarginLeft ? "text-[12px] mx-2" : "text-lg mx-4"
          }`}
        >
          نرخ ارز
        </div>

        <div
          className={`text-[#f8be13] my-auto  text-sm font-semibold screen500:text-xs screen450:text-[9px] screen500:-mr-1  
         
        ${showSidbarMarginLeft && "screen450:hidden "}
        `}
        >
          <span className="screen700:hidden">تاریخ آخرین</span>

          <span> به روز رسانی : </span>

          <span>{currUpdatedAt?.split(" ")[0]}</span>
          <span className="mx-3 screen450:mx-1">
          {currUpdatedAt?.split(" ")[1]}
            {/* {+(Number(currUpdatedAt?.split(" ")[1].split(":")[0]) + 1) +
              ":" +
              currUpdatedAt?.split(" ")[1].split(":")[1]} */}
          </span>
        </div>
      </div>
      <div
        style={{ direction: "rtl" }}
        className="grid grid-cols-2 place-items-center gap-3 w-[60%]  mx-auto screen800:w-[78%] 
         screen700:w-[82%] screen500:grid-cols-1  screen500:gap-0 screen500:gap-y-3 screen370:w-[100%]"
      >
        {data?.slice(0, 2).map((item) => {
          return (
            <CurrencyItems
              swiper={false}
              key={item.id}
              items={item}
              showSidbarMarginLeft={showSidbarMarginLeft}
            />
          );
        })}
      </div>
      <div className={`mt-14 ${showSidbarMarginLeft && "hidden"} `}>
        <SwiperCurrency data={data?.slice(2, 18)} />
      </div>
    </div>
  );
};

export default Currency;
